/**
 * Channel types for conversations
 */
export enum ConversationChannelEnum {
  /**
   * Email conversation
   */
  EMAIL = "email",

  /**
   * SMS conversation
   */
  SMS = "sms",

  /**
   * WhatsApp conversation
   */
  WHATSAPP = "whatsapp"
}
